<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="flex justify-between my-3">
  <h2>Customers</h2>
  <button class="btn_add_new" *appHasAnyPrivilege="'CUSTOMER_CREATE'" nz-button nzType="primary" (click)="navigateNewCustomer()">
    Add New Customer
  </button>
</div>


<section id="customer-records">

  <nz-card>
    <div class="flex flex-col gap-3">
      <div [ngClass]="loading ? 'hidden' : 'block'">
        <nz-collapse>
          <nz-collapse-panel [nzHeader]="'Advanced Search'">
            <div class="flex flex-col lg:flex-row sm:justify-between 2xl:items-center gap-4">
              <div class="flex flex-col xl:flex-row xl:items-center gap-2 xl:gap-0">
                <nz-input-group nzSearch [nzAddOnAfter]="suffixIconSearchButton">
                  <input type="text" (keydown.enter)="search()" [(ngModel)]="searchText" nz-input placeholder="Search here"/>
                </nz-input-group>

                <ng-template #suffixIconSearchButton>
                  <button nz-button nzType="primary" nzSearch class="bg-[#6B6C6E] border-[#6B6C6E]" (click)="search()">
                    <span nz-icon nzType="search"></span>
                  </button>
                </ng-template>
                <nz-divider
                  class="hidden lg:block"
                  [nzType]="'vertical'"
                ></nz-divider>


              </div>

              <div>
                <button nz-button nzBlock class="outline-button" (click)="resetSearch()">
                  Reset All
                </button>
              </div>

            </div>
          </nz-collapse-panel>
        </nz-collapse>
      </div>

      <div [ngClass]="loading ? 'hidden' : 'block'" class="table-card">
        <div class="table-obj">
          <nz-table
            #basicTable [nzData]="customerData" [nzShowSizeChanger]="pageSize.length > 5"
            [nzPageSizeOptions]="pageSize.pageSizeOptions" [nzPageSize]="pageSize.pageSize"
            [nzPageIndex]="pageSize.pageIndex" [nzFrontPagination]="false" [nzTotal]="pageSize.length"
            (nzQueryParams)="onTableParamsChange($event)" nzTableLayout="fixed" [nzScroll]="{ x: 'auto', y: '550px' }"
            nzOuterBordered 
          >
            <thead>
            <tr>
              <th>Customer ID</th>
              <th>Customer Name</th>
              <th>Country</th>
              <th>Contact Number</th>
              <th>
                <span>Created Date</span>
                <span *ngIf="sortOrder === -1" nz-icon nzType="up" nzTheme="outline"
                      class="ml-2 mr-1 p-1 w-2 h-2 cursor-pointer" (click)="sort()">
                  </span>
                <span *ngIf="sortOrder === 1" nz-icon nzType="down" nzTheme="outline"
                      class="ml-2 mr-1 p-1 w-2 h-2 cursor-pointer" (click)="sort()">
                  </span></th>
              <th *appHasAnyPrivilege="'CUSTOMER_SINGLE_VIEW,CUSTOMER_DELETE,CUSTOMER_UPDATE'">Actions</th>

            </tr>
            </thead>
            <tbody>

            <!--        Normal Repairs entry-->
            <tr *ngFor="let data of basicTable.data" class="align-baseline">
              <td style="min-width: 100px;">
                <a *appHasAnyPrivilege="'CUSTOMER_SINGLE_VIEW'" class="clickable-text"
                   (click)="navigateToSingle(this.data._id)">{{data.customerId}}</a>
                <span *ngIf="!hasPermission('CUSTOMER_SINGLE_VIEW')">{{data.customerId}}</span>
              </td>
              <td style="min-width: 150px; white-space: nowrap">{{ data.renterDetails.fullName}}</td>
              <td style="min-width: 150px;">{{data.renterDetails.homeCountry}}</td>
              <td style="min-width: 150px;"class="clickable-mail-phone_no"><a class="clickable-mail-phone_no" href="tel:{{data.renterDetails.contactNo}}">{{data.renterDetails.contactNo}}</a></td>
              <td style="min-width: 150px;">{{ data.createdAt | date:'yyyy-MM-dd' }}</td>
              <td *appHasAnyPrivilege="'CUSTOMER_SINGLE_VIEW,CUSTOMER_DELETE,CUSTOMER_UPDATE'">
                <button *appHasAnyPrivilege="'CUSTOMER_UPDATE'" class="outline-button mr-3" nz-button nzType="default"
                        (click)="editNavigate(this.data._id)">
                  Edit
                </button>
                <button *appHasAnyPrivilege="'CUSTOMER_SINGLE_VIEW,CUSTOMER_DELETE'"
                        class="outline-button more-dropdown"
                        nz-button
                        nz-dropdown
                        [nzDropdownMenu]="menu"
                        nzPlacement="bottomCenter"
                >
                  <span nz-icon nzType="more" nzTheme="outline"></span>
                </button>
                <nz-dropdown-menu #menu="nzDropdownMenu">
                  <ul nz-menu>
                    <li *appHasAnyPrivilege="'CUSTOMER_SINGLE_VIEW'" nz-menu-item nz-popconfirm nz-button
                        (click)="navigateToSingle(data._id)">View
                    </li>
                    <a *appHasAnyPrivilege="'CUSTOMER_DELETE'"
                       nz-popconfirm
                       nzPopconfirmTitle="Are you sure delete this Customer?"
                       nzPopconfirmPlacement="bottom"
                       (nzOnConfirm)="deleteCustomer(this.data._id)"
                    >
                      <li nz-menu-item nz-popconfirm nz-button nzDanger>Delete</li>
                    </a>
                  </ul>
                </nz-dropdown-menu>
              </td>
            </tr>

            </tbody>
          </nz-table>
        </div>
      </div>
      <div [ngClass]="loading ? 'block' : 'hidden'">
        <app-table-skeleton-template [columnData]="skeletonTableColumns"></app-table-skeleton-template>
      </div>
    </div>
  </nz-card>

</section>
